/**
 * Splits rule groups into chains. Groups joined with AND form a chain, and chains are
 * joined with OR, so AND is applied before OR. Shared by the server's query builder and
 * the program rule builder's summary.
 *
 * @param {Array} ruleGroups - groups with a joinWithPrevious of 'AND', 'OR' or null, in order
 * @returns {Array<Array>} one array of groups per chain
 */
export function toChains(ruleGroups) {
    const chains = [];
    ruleGroups.forEach((group, index) => {
        if (index === 0 || group.joinWithPrevious !== 'AND') chains.push([group]);
        else chains.at(-1).push(group);
    });
    return chains;
}

/**
 * Names a chain's groups, e.g. "Rain Boots", "both Work Boots and Carhartt" or "all of A, B and C".
 *
 * @param {string[]} names - the chain's group names
 * @returns {string}
 */
export function nameChain(names) {
    if (names.length === 1) return names[0];
    return `${names.length === 2 ? 'both' : 'all of'} ${names.slice(0, -1).join(', ')} and ${names.at(-1)}`;
}

/**
 * What a voucher has to buy, e.g. "one item that matches both Work Boots and Carhartt, or one item
 * from Rain Boots". An item meets a chain only by matching every group in it, not one item per
 * group. Shared by the checkout refusal, the voucher page and the program rule builder's summary.
 *
 * @param {string[][]} requiredChains - each required chain's group names
 * @returns {string}
 */
export function describeRequiredChains(requiredChains) {
    return requiredChains.map((names) => (names.length === 1 ? `one item from ${names[0]}` : `one item that matches ${nameChain(names)}`)).join(', or ');
}
